<section
  fxLayout="column"
  fxLayoutAlign="center center"
  class="camera-tutorial"
>
  <img
    src="/assets/icons/shapes/close.svg"
    alt=""
    class="close-modal"
    (click)="this.dialogRef.close();"
  >
  <h2
    mat-dialog-title
    class="tutorial-title"
  >
    <i>
      Cum controlezi camera
    </i>
  </h2>
  <mat-dialog-content>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center center"
    class="tutorial-items-list"
  >
    <div
      class="tutorial-item"
      style="background-image: url('/assets/images/about-us/header_background.jpg')">
    </div>
    <div
      class="tutorial-item"
      style="background-image: url('/assets/images/about-us/header_background.jpg')">
    </div>
    <div
      class="tutorial-item"
      style="background-image: url('/assets/images/about-us/header_background.jpg')">
    </div>
  </div>
  </mat-dialog-content>
</section>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/show-camera-tutorial-modal-base/show-camera-tutorial-modal-base.component.html